export var UpdateType = /*#__PURE__*/ function(UpdateType) {
    UpdateType[UpdateType["NO_UPDATE"] = 0] = "NO_UPDATE";
    UpdateType[UpdateType["MANIFEST_UPDATE"] = 1] = "MANIFEST_UPDATE";
    UpdateType[UpdateType["TIMELINE_UPDATE"] = 2] = "TIMELINE_UPDATE";
    return UpdateType;
}({});

//# sourceMappingURL=meta-list.enums.js.map